import {getToken, getUuidMake} from "../Common";
import axios from "axios";
import {getTodayDateTime} from "../Common2";
import {shopMapping} from "./mappingService";
import {BACK_OFFICE_API, ORDER_PROXY_API, ORDER_API, POS_API} from "../../../constants/apiUrls"
import {getShopMappingApi} from "../../../api/MappingApi";

const token = getToken();

export const getShopInfoApi = async (shopId) => {
  try {
    const response = await axios.get(`${ORDER_API}/shop/info/ceo/${shopId}`, {
      headers: {Authorization: `Bearer ${token}`}
    });
    return response.data;
  } catch (e) {
    console.log(e);
  }
}
export const getShopAdminInfoApi = async (shopId) => {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/shop/detail/admin/${shopId}`);
      return response.data;
    }
  } catch (e) {
    console.log(e);
  }
}
export async function getShopAdminDetailApi(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/shop/${shopId}`);
      return response.data[0];
    }
  } catch (error) {
    console.log(error);
  }
}






export async function getShopInfo(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/shop/info/ceo/${shopId}`, {
        headers: {Authorization: `Bearer ceo`}
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

export async function getShopAdminDetail(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/shop/detail/admin/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

export async function getAdminShopInfo(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/shop/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 이미지 조회
export async function getImageList(shopId, type) {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/shop/image`, {
        params: {
          shopId: shopId,
          imageType: type
        }
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}


// 카테고리 조회
export async function getCategory(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/shop/detail/admin/${shopId}`);
      return response.data.categoryList;
    }
  } catch (error) {
    console.log(error);
  }
}

// 주문 채널 기상 할증 조회
export const getOrderWeatherCostApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/cost/extra/weather/ceo`, {
    params: {shopId: shopId},
    headers: { Authorization: `Bearer ceo` }
  });
  return response.data;
}

// 상점 기본정보 수정
export async function modifyShopInfo1(data) {
  let orderData = {};

  if (data.name) orderData.name = data.name;
  if (data.status !== data.prevStatus) orderData.status = Number(data.status);
  if (data.tel) orderData.tel = data.tel;
  if (data.deliveryDoneMinutes) orderData.deliveryDoneMinutes = data.deliveryDoneMinutes;
  if (data.packagingDoneMinutes) orderData.packagingDoneMinutes = data.packagingDoneMinutes;
  if (data.intro) orderData.intro = data.intro;
  if (data.notice) orderData.notice = data.notice;
  if (data.road) orderData.road = data.road;
  if (data.lat) orderData.lat = data.lat;
  if (data.lng) orderData.lng = data.lng;
  if (data.jibun) orderData.jibun = data.jibun;
  if (data.addressDetail) orderData.addressDetail = data.addressDetail;

  if (data.addImageFileList.length > 0) orderData.addImageFileList = data.addImageFileList;
  if (data.setImageFileList.length > 0) orderData.setImageFileList = data.setImageFileList;
  if (data.removeImageFileIdList.length > 0) orderData.removeImageFileIdList = data.removeImageFileIdList;
  if (data.addFreeImageIds?.length > 0) orderData.addFreeImageIds = data.addFreeImageIds;

  const posShopId = await getShopMappingApi(data.shopId);
  const uuid = getUuidMake(posShopId);

  if (Object.keys(orderData).length === 0 && orderData.constructor === Object) {
    document.getElementById("shopInfo1Btn").removeAttribute("disabled");
    alert("수정된 내용이 없습니다.");
  } else {
    await axios.put(`${ORDER_API}/shop/v2/${data.shopId}`, orderData);

    // POS 데이터 업데이트
    let posData = {};
    if (orderData.name) posData.shopName = orderData.name;
    if (orderData.tel) posData.shopTel = orderData.tel;
    if (orderData.deliveryDoneMinutes) posData.deliveryCompleteTime = orderData.deliveryDoneMinutes;
    if (orderData.packagingDoneMinutes) posData.wrapCompleteTime = orderData.packagingDoneMinutes;
    if (orderData.jibun) posData.jibunAddress = orderData.jibun;
    if (orderData.road) posData.roadAddress = orderData.road;
    if (orderData.addressDetail) posData.addressDetail = orderData.addressDetail;
    if (orderData.lat) posData.latitude = orderData.lat;
    if (orderData.lng) posData.longitude = orderData.lng;

    if (Object.keys(posData).length === 0 && posData.constructor === Object) {

    } else {
      posData.uuid = uuid;
      posData.modifierId = Number(posShopId);
      posData.modifierType = 1;
      posData.shopId = Number(posShopId);

      await axios.put(`${POS_API}/shop/v2`, posData);
    }

    if (Number(orderData.status) && Number(orderData.status) !== Number(data.prevStatus)) {
      const status = Number(orderData.status);
      const prevStatus = Number(data.prevStatus);
      const posTopShop = await axios.get(`${POS_API}/shop/v2/top-id`, {
        params: {
          shopIdList: Number(posShopId)
        }
      });
      const posTopShopId = posTopShop.data[0].topShopId;
      const today = getTodayDateTime();

      if (status === 6 && prevStatus === 5) {
        await axios.put(`${POS_API}/shop/v2/status/pause`, {
          uuid: uuid,
          modifierId: posShopId,
          modifierType: 1,
          topShopId: posTopShopId,
          shopStatusItemList: [{
            shopId: posShopId,
            shopStatus: 6
          }]
        });
      } else if (status === 6 && prevStatus !== 5) {
        await axios.put(`${POS_API}/shop/v2/status`, {
          uuid: uuid,
          modifierId: Number(posShopId),
          modifierType: 1,
          topShopId: Number(posTopShopId),
          shopId: Number(posShopId),
          shopStatus: Number(orderData.status),
          prevShopStatus: Number(data.prevStatus),
          salesStartDateTime: today
        });
      } else if (status === 7) {
        await axios.put(`${POS_API}/shop/v2/status`, {
          uuid: uuid,
          modifierId: Number(posShopId),
          modifierType: 1,
          topShopId: Number(posTopShopId),
          shopId: Number(posShopId),
          shopStatus: Number(orderData.status),
          prevShopStatus: Number(data.prevStatus),
          salesEndDateTime: today
        });
      }
    }

    window.location.reload();
  }

  // 포스 조회
  /*axios.get(`${outsideApi}/shop`, {
    params: {
      channelType: 2,
      shopId: data.shopId
    }
  }).then((response) => {
    console.log("주문 채널 상점 수정");
    let posId = response.data.shopId;
    let uuidMake = Common.uuidMake()
    let uuid = `S-${ posId }${ uuidMake }`

    console.log(orderData);

    axios.put(`${ORDER_API}/shop/v2/${data.shopId}`, orderData).then(() => {
      console.log("포스 채널 상점 수정");
      let posData = {
        uuid: uuid,
        modifierId: Number(posId),
        modifierType: 1,
        shopId: Number(posId),
      }
      if (data.name) {
        posData.shopName = data.name;
      }
      if (data.tel) {
        posData.shopTel = data.tel;
      }
      if (data.deliveryDoneMinutes) {
        posData.deliveryCompleteTime = data.deliveryDoneMinutes;
      }
      if (data.packagingDoneMinutes) {
        posData.wrapCompleteTime = data.packagingDoneMinutes;
      }
      // 포스 채널 상점 수정
      axios.put(`${POS_API}/shop/v2`, posData)
    }).then(() => {
      axios.get(`${POS_API}/shop/v2/top-id`, {
        params: {
          shopIdList: Number(posId)
        }
      }).then((response) => {
        let topPosId = response.data[0].topShopId;
        let today = getTodayDateTime();

        if(Number(data.shopStatus) !== Number(data.prevStatus)) {
          if(Number(data.shopStatus) === 6 && Number(data.prevStatus) === 5) {
            axios.put(`${POS_API}/shop/v2/status/pause`, {
              uuid: uuid,
              modifierId: posId,
              modifierType: 1,
              topShopId: topPosId,
              shopStatusItemList: [{
                shopId: posId,
                shopStatus: 6
              }]
            }).then(function() {
              window.location.reload()
            })
          } else if(Number(data.shopStatus) === 6 && Number(data.prevStatus) !== 5) {
            axios.put(`${POS_API}/shop/v2/status`, {
              uuid: uuid,
              modifierId: Number(posId),
              modifierType: 1,
              topShopId: Number(topPosId),
              shopId: Number(posId),
              shopStatus: Number(data.shopStatus),
              prevShopStatus: Number(data.prevStatus),
              salesStartDateTime: today
            }).then(function() {
              //window.location.reload()
            })
          } else if(Number(data.shopStatus) === 7) {
            axios.put(`${POS_API}/shop/v2/status`, {
              uuid: uuid,
              modifierId: Number(posId),
              modifierType: 1,
              topShopId: Number(topPosId),
              shopId: Number(posId),
              shopStatus: Number(data.shopStatus),
              prevShopStatus: Number(data.prevStatus),
              salesEndDateTime: today
            }).then(function() {
              //window.location.reload()
            })
          } else {
            //window.location.reload()
          }
        } else {
          //window.location.reload()
        }
      })
    })
  })*/
}

// 주문채널 상점만 수정 시
export async function modifyOrderShop(data, shopId) {
  axios.put(`${ORDER_API}/shop/v2/${shopId}`, data).then(function() {
    window.location.reload()
  })
}

// 대표 이미지 삭제
export async function deleteShopImage(data, shopId) {
  axios.put(`${ORDER_API}/shop/v2/${shopId}`, {
    removeImageFileIdList: [Number(data)]
  }).then(function() {
    window.location.reload()
  })
}

// 행정동 조회
export async function getDongList(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/extra/deliPbtAdd/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 법정공휴일 조회
export async function getHolidayList() {
  try {
    const response = await axios.get(`${BACK_OFFICE_API}/holiday`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

// 영업시간 조회
export async function getShopTime(shopId) {
  try {
    const response = await axios.get(`${BACK_OFFICE_API}/opertime/${shopId}`, shopId);

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

// 기준배달비 조회
export async function getDeliveryCost(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/extra/deli/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 행정동별 배달비 조회
export async function getDongCost(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/extra/dong/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 거리별 배달비 조회
export async function getDistCost(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/extra/dist/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 법정공휴일별 배달비 조회
export async function getShopHolidayCost(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/extra/holiday/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 시간대별 배달비 조회
export async function getTimeCost(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/extra/time/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 상점 휴일 조회
export async function getShopHoliday(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/shopholiday/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 상점 법정공휴일 조회
export async function getShopLegalHoliday(shopId) {
  try {
    if(shopId) {
      const response = await axios.get(`${BACK_OFFICE_API}/shopLegalholiday/${shopId}`);
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 카테고리 조회
export const getAllCategory = async (serviceType) => {
  try {
    if(serviceType) {
      const response = await axios.get(`${BACK_OFFICE_API}/category/v2`, {
        params: {
          chanlTpcd: 2,
          serviceTpcd: serviceType
        }
      });

      return response.data;
    }
  } catch (e) {
    console.log(e);
  }
}

// 상점 등록
export const newShop = (data) => {
  axios.post(`${ORDER_API}/shop/v2`, data).then((response) => {
    let shopId = response.data.shopId
    let posId = response.data.posShopId

    axios.post(`${ORDER_PROXY_API}/shop/v2/mapping/code`, {
      channelType: 2,
      posShopId: Number(posId),
      orderShopId: String(shopId)
    }).then(() => {
      alert("신규 상점이 등록되었습니다.");
      window.location.href = "/v2/shopAppList";
    }).catch((e) => {
      console.log(e);
      alert("상점 매핑이 실패했습니다.");
    });
  }).catch((e) => {
    console.log(e);
    alert("상점 등록이 실패했습니다.");
  });
}

// 상점 원산지 조회
export const getShopOrigin = async (shopId) => {
  const token = getToken();

  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/shop/coo-info/ceo`, {
        params: {
          page: 1,
          count: 15,
          shopId: shopId,
        },
        headers: {Authorization: `Bearer ${token}`}
      });

      return response.data;
    }
  } catch (e) {
    console.log(e)
  }
}

// 상품 원산지 수정
export const modifyOrigin = (shopId, data) => {
  axios.put(`${ORDER_API}/shop/v2/${shopId}`, {
    cooInfo: data
  }).then(function() {
    window.location.reload()
  })
}

// 운영 목록 조회
export const getStoreListApi = async (userId, userType) => {
  try {
    let shopList;

    if(userType === 4) {
      let shopInfo = await axios.get(`${BACK_OFFICE_API}/shop/${userId}`);
      shopList = shopInfo.data;
    } else {
      let getShopList = await axios.get(`${BACK_OFFICE_API}/shop/downShopList`, {
         params: {
           chanlTpcd: 2,
          topShopId: userId
        }
      });
      shopList = getShopList.data;
    }
    return shopList;
  } catch(e) {
    console.log(e)
  }
}

// 하위 상점 조회
export const getShopLowerApi = async (shopId) => {
  const token = getToken();

  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/shop/lower`, {
        params: {
          page: 1,
          count: 15,
          shopId: shopId,
        },
        headers: {Authorization: `Bearer ${token}`}
      });

      return response.data;
    }
  } catch (e) {
    console.log(e)
  }
}

// 상점 임시 영업 정지
export const shopStopApi = async (shopId, startTs, endTs) => {
  const posShopId = await shopMapping(shopId);
  const posTopShopId = await getPosTopShopApi(posShopId);
  const uuid = getUuidMake(posShopId);

  await orderShopStopApi(shopId, startTs, endTs);
  await posShopStopApi(posShopId, posTopShopId, startTs, endTs, uuid);
}

// 주문 채널 상점 임시 정지
export const orderShopStopApi = async (shopId, startTs, endTs) => {
  await axios.put(`${ORDER_API}/shop/v2/${shopId}`, {
    pauseStartDateTime: startTs,
    pauseEndDateTime: endTs,
    status: 5,
    approvalType1: 4,
    approvalType2: 5
  });
}
// 포스 채널 상점 임시 정지
export const posShopStopApi = async (shopId, topShopId, startTs, endTs, uuid) => {
  await axios.put(`${POS_API}/shop/v2/status/pause`, {
    uuid: uuid,
    modifierId: 1,
    modifierType: 2,
    topShopId: topShopId,
    shopStatusItemList: [{
      shopId: shopId,
      shopStatus: 5,
      pauseStartDateTime: startTs,
      pauseEndDateTime: endTs
    }]
  });
}

// 상점 임시 영업 정지 해제
export const shopOpenApi = async (shopId) => {
  const posShopId = await shopMapping(shopId);
  const posTopShopId = await getPosTopShopApi(posShopId);
  const uuid = getUuidMake(posShopId);

  await orderShopOpenApi(shopId);
  await posShopOpenApi(posShopId, posTopShopId, uuid);
}
// 주문 채널 상점 임시 정지 해제
export const orderShopOpenApi = async (shopId) => {
  await axios.put(`${ORDER_API}/shop/v2/${shopId}`, {
    status: 6,
    approvalType1: 4,
    approvalType2: 5
  });
}
// 포스 채널 상점 임시 정지 해제
export const posShopOpenApi = async (shopId, topShopId, uuid) => {
  await axios.put(`${POS_API}/shop/v2/status/pause`, {
    uuid: uuid,
    modifierId: 1,
    modifierType: 2,
    topShopId: topShopId,
    shopStatusItemList: [{
      shopId: shopId,
      shopStatus: 6
    }]
  });
}

// 포스 채널 상위 상점 조회
export const getPosTopShopApi = async (shopId) => {
  try {
    if(shopId) {
      const response = await axios.get(`${POS_API}/shop/v2/top-id`, {
        params: {
          shopIdList: shopId
        }
      });
      return response.data[0].topShopId;
    }
  } catch (e) {
    console.log(e)
  }
}

// 주문 채널 무료 배달비 설정 조회
export const getFreeCostApi = async (shopId) => {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/cost/delivery/free/ceo`, {
        params: {
          shopId: shopId
        },
        headers: {Authorization: `Bearer ceo-${shopId}`}
      });
      return response.data;
    }
  } catch (e) {
    console.log(e)
  }
}

// 주문 채널 거리별 배달비 설정 조회
export const getDistanceApi = async (shopId) => {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/cost/extra/distance`, {
        params: {
          shopId: shopId
        }
      });
      return response.data;
    }
  } catch (e) {
    console.log(e)
  }
}

// 주문 채널 무료 배달비 설정 추가
export const addFreeConstApi = async (data) => {
  await axios.post(`${ORDER_API}/cost/delivery/free`, data);
}